import client from '../../providers/fetchClient'

export const getMaritalTypes = () => client.get('/v3/marital-types')
